// FotosMLPhotoroom
// Uploader dual (frontal + cenital) → llama edge fn photoroom-generar-variantes
// → muestra 3 tarjetas resultado (blanca / bone / cenital)
// → botón "🔄 Usar en tienda Limpack" al lado de la bone (swap productos.foto_url)
//
// Modo mock activo hasta que se cargue PHOTOROOM_API_KEY en secrets.

import { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabase'

const BUCKET_ORIGEN = 'productos-fotos-ml'
const CONTEXTOS_ORDEN = ['fondo_blanco', 'bone_limpack', 'cenital']

export default function FotosMLPhotoroom({ productoId, productoSku, onFotoTiendaSwap }) {
  const [fotos, setFotos] = useState([])
  const [loading, setLoading] = useState(true)
  const [frontalFile, setFrontalFile] = useState(null)
  const [cenitalFile, setCenitalFile] = useState(null)
  const [uploading, setUploading] = useState(false)
  const [generating, setGenerating] = useState(false)
  const [error, setError] = useState(null)
  const [modoUltima, setModoUltima] = useState(null)
  const [pathsSubidos, setPathsSubidos] = useState({ frontal: null, cenital: null })
  const [swapping, setSwapping] = useState(false)

  useEffect(() => { if (productoId) cargar() }, [productoId])

  async function cargar() {
    setLoading(true)
    const { data, error } = await supabase
      .from('ml_fotos')
      .select('*')
      .eq('producto_id', productoId)
      .eq('tipo', 'ia')
      .in('contexto', CONTEXTOS_ORDEN)
      .in('generation_model', ['photoroom', 'photoroom-mock'])
      .order('posicion', { ascending: true })
      .order('created_at', { ascending: false })
    if (error) console.error('[FotosMLPhotoroom]', error)
    // Nos quedamos con la última de cada contexto
    const porContexto = new Map()
    for (const f of (data || [])) {
      if (!porContexto.has(f.contexto)) porContexto.set(f.contexto, f)
    }
    setFotos(CONTEXTOS_ORDEN.map(c => porContexto.get(c)).filter(Boolean))
    setLoading(false)
  }

  async function subirOriginal(file, tag) {
    const ext = (file.name.split('.').pop() || 'jpg').toLowerCase()
    const path = `${productoId}/original-${tag}-${Date.now()}.${ext}`
    const { error } = await supabase.storage.from(BUCKET_ORIGEN).upload(path, file, {
      contentType: file.type || 'image/jpeg',
      upsert: false,
    })
    if (error) throw error
    return path
  }

  async function generar() {
    setError(null)
    if (!frontalFile) { setError('Falta la foto frontal'); return }
    setUploading(true)
    try {
      const pathFrontal = await subirOriginal(frontalFile, 'frontal')
      const pathCenital = cenitalFile ? await subirOriginal(cenitalFile, 'cenital') : null
      setPathsSubidos({ frontal: pathFrontal, cenital: pathCenital })
      setUploading(false)
      setGenerating(true)
      const { data, error } = await supabase.functions.invoke('photoroom-generar-variantes', {
        body: {
          producto_id: productoId,
          path_frontal: pathFrontal,
          path_cenital: pathCenital,
        },
      })
      if (error) throw error
      setModoUltima(data?.modo || 'mock')
      setFrontalFile(null)
      setCenitalFile(null)
      await cargar()
    } catch (e) {
      setError(e.message || String(e))
    } finally {
      setUploading(false)
      setGenerating(false)
    }
  }

  async function usarEnTienda(foto) {
    if (!confirm('¿Reemplazar la foto oficial de tienda Limpack por esta variante bone?')) return
    setSwapping(true)
    try {
      const { error } = await supabase
        .from('productos')
        .update({ foto_url: foto.ml_picture_url, updated_at: new Date().toISOString() })
        .eq('id', productoId)
      if (error) throw error
      alert('✅ Foto de tienda actualizada')
      onFotoTiendaSwap && onFotoTiendaSwap(foto.ml_picture_url)
    } catch (e) {
      alert('Error: ' + (e.message || e))
    } finally {
      setSwapping(false)
    }
  }

  const yaTiene3 = fotos.length === 3

  return (
    <div style={{
      background: '#fff', border: '1px solid #E5E7EB', borderRadius: 12,
      padding: 16, marginTop: 8,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 12 }}>
        <div>
          <h4 style={{ margin: 0, fontSize: 14, fontWeight: 800, color: '#1A3461' }}>
            📸 Fotos MELI (Photoroom · 3 variantes)
          </h4>
          <p style={{ margin: '3px 0 0', fontSize: 11.5, color: '#64748B' }}>
            Fondo blanco (portada) · Bone ambientada · Cenital · USD 0,30 por producto
          </p>
        </div>
        {modoUltima && (
          <span style={{
            fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 999,
            background: modoUltima === 'real' ? '#DCFCE7' : '#FEF3C7',
            color: modoUltima === 'real' ? '#166534' : '#78350F',
          }}>
            {modoUltima === 'real' ? '🟢 Photoroom real' : '🟡 Modo mock (sin API key)'}
          </span>
        )}
      </div>

      {/* Grid con las 3 variantes */}
      {loading ? (
        <div style={{ fontSize: 13, color: '#64748B', padding: 20, textAlign: 'center' }}>Cargando…</div>
      ) : yaTiene3 ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
          {fotos.map(f => (
            <VarianteCard
              key={f.id}
              foto={f}
              productoSku={productoSku}
              onUsarEnTienda={f.contexto === 'bone_limpack' ? () => usarEnTienda(f) : null}
              swapping={swapping}
            />
          ))}
        </div>
      ) : (
        <div style={{
          padding: 16, background: '#F8FAFC', border: '1px dashed #CBD5E1',
          borderRadius: 8, marginBottom: 12,
        }}>
          <p style={{ margin: '0 0 8px', fontSize: 12.5, color: '#374151', fontWeight: 600 }}>
            Todavía no generaste las 3 variantes de este SKU.
          </p>
          <p style={{ margin: 0, fontSize: 11.5, color: '#64748B' }}>
            Subí una foto frontal (obligatoria) y una cenital (opcional) — Photoroom saca las 3 versiones.
          </p>
        </div>
      )}

      {/* Uploader */}
      <div style={{
        marginTop: 14, padding: 14, background: '#F8FAFC', borderRadius: 8, border: '1px solid #E2E8F0',
      }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <FileInput
            label="Foto frontal (obligatoria)"
            hint="Packshot vertical del envase"
            file={frontalFile}
            onChange={setFrontalFile}
          />
          <FileInput
            label="Foto cenital (opcional)"
            hint="Top-down desde arriba"
            file={cenitalFile}
            onChange={setCenitalFile}
          />
        </div>
        {error && (
          <div style={{
            marginTop: 10, padding: '8px 12px', background: '#FEE2E2',
            border: '1px solid #FCA5A5', borderRadius: 6, fontSize: 12, color: '#991B1B',
          }}>⚠️ {error}</div>
        )}
        <button
          onClick={generar}
          disabled={uploading || generating || !frontalFile}
          style={{
            marginTop: 12,
            background: !frontalFile ? '#CBD5E1' : '#1A3461',
            color: '#fff', border: 'none', padding: '10px 18px', borderRadius: 8,
            fontSize: 13, fontWeight: 700, cursor: !frontalFile ? 'not-allowed' : 'pointer',
          }}
        >
          {uploading ? 'Subiendo…' : generating ? 'Generando con Photoroom…' : yaTiene3 ? '🔄 Regenerar 3 variantes' : '🎨 Generar 3 variantes'}
        </button>
      </div>
    </div>
  )
}

function VarianteCard({ foto, productoSku, onUsarEnTienda, swapping }) {
  const meta = {
    fondo_blanco: { label: '1. Blanca', desc: 'Portada MELI', badge: '#DBEAFE', badgeText: '#1E3A8A' },
    bone_limpack: { label: '2. Ambientada', desc: 'Bone #F8F6F1', badge: '#FEF3C7', badgeText: '#78350F' },
    cenital:      { label: '3. Cenital', desc: 'Top-down', badge: '#DCFCE7', badgeText: '#166534' },
  }[foto.contexto] || { label: foto.contexto, desc: '', badge: '#F3F4F6', badgeText: '#374151' }

  return (
    <div style={{
      border: '1px solid #E5E7EB', borderRadius: 10, overflow: 'hidden',
      display: 'flex', flexDirection: 'column',
    }}>
      <div style={{ position: 'relative', aspectRatio: '1/1', background: '#F8FAFC' }}>
        <img
          src={foto.ml_picture_url}
          alt={foto.contexto}
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
        {foto.es_portada && (
          <span style={{
            position: 'absolute', top: 6, left: 6,
            background: '#3B82F6', color: '#fff', fontSize: 10, fontWeight: 700,
            padding: '2px 8px', borderRadius: 999,
          }}>⭐ Portada</span>
        )}
      </div>
      <div style={{ padding: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <strong style={{ fontSize: 12, color: '#1A3461' }}>{meta.label}</strong>
          <span style={{
            fontSize: 9, fontWeight: 700, padding: '2px 6px', borderRadius: 4,
            background: meta.badge, color: meta.badgeText,
          }}>{meta.desc}</span>
        </div>
        {onUsarEnTienda && (
          <button
            onClick={onUsarEnTienda}
            disabled={swapping}
            style={{
              width: '100%', marginTop: 8, padding: '7px 10px', borderRadius: 6,
              background: '#00A8B5', color: '#fff', border: 'none', fontSize: 11, fontWeight: 700,
              cursor: swapping ? 'wait' : 'pointer',
            }}
          >
            {swapping ? 'Aplicando…' : '🔄 Usar en tienda Limpack'}
          </button>
        )}
      </div>
    </div>
  )
}

function FileInput({ label, hint, file, onChange }) {
  return (
    <label style={{ display: 'block' }}>
      <div style={{ fontSize: 11.5, fontWeight: 700, color: '#1A3461', marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 10, color: '#64748B', marginBottom: 6 }}>{hint}</div>
      <input
        type="file"
        accept="image/*"
        onChange={e => onChange(e.target.files?.[0] || null)}
        style={{ fontSize: 11, width: '100%' }}
      />
      {file && (
        <div style={{ marginTop: 4, fontSize: 10.5, color: '#166534' }}>
          ✓ {file.name} ({(file.size / 1024).toFixed(0)} KB)
        </div>
      )}
    </label>
  )
}
